// Plan-access chips (PX-385) — extracted from Photoshoots.tsx so both the
// editor modal, the legacy list row, AND the new table (PX-386) share one
// definition. Rendered as `role="button"` spans (not <button>) so a chip nests
// validly inside a parent <button>/clickable row; clicks stopPropagation so a
// chip never bubbles up to open the editor. Empty selection = visible to
// everyone (rank-semantics).
import type { AdminPlanResponse } from '@/types/api'

export function PlanChips({
  plans,
  selectedIds,
  onToggle,
  disabled,
  compact,
}: {
  plans: AdminPlanResponse[]
  selectedIds: number[]
  onToggle: (planId: number) => void
  disabled?: boolean
  compact?: boolean
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {plans.map((plan) => {
        const checked = selectedIds.includes(plan.id)
        return (
          <span
            key={plan.id}
            role="button"
            aria-pressed={checked}
            aria-disabled={disabled}
            onClick={(e) => {
              e.stopPropagation()
              if (!disabled) onToggle(plan.id)
            }}
            className={`cursor-pointer select-none rounded-md border font-medium transition ${
              disabled ? 'cursor-not-allowed opacity-60' : ''
            } ${compact ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1.5 text-xs'} ${
              checked
                ? 'border-brand-500 bg-brand-50 text-brand-700'
                : 'border-ink-200 bg-white text-ink-500 hover:border-ink-300'
            }`}
          >
            {plan.name}
            {!compact && <span className="ml-1 font-mono opacity-60">#{plan.id}/r{plan.rank}</span>}
          </span>
        )
      })}
    </div>
  )
}
